import React, { useRef } from "react";
import sanitizeHtml from "sanitize-html";
import { Parser } from "html-to-react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Slide, SlideshowRef } from "react-slideshow-image";

import "react-slideshow-image/dist/styles.css";

import "./styles.scss";
import { API_URL } from "../../config/Constants";
import VideoPreview from "../VideoPreview";
import { useNavigate } from "react-router-dom";

export type SlideItem = {
  title: string;
  media: string;
  id: string;
  body: string;
  order?: number;
  moreInfo?: string;
  moreInfoLabel?: string;
};

export type Props = {
  data: Array<SlideItem>;
  startPlayingTitle: string;
};

const responsiveSettings = [
  {
    breakpoint: 700,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 450,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
];

const isVideoByDomain = (url: string): boolean => {
  const videoExtensions = [".mp4", ".avi", ".mov", ".mkv"]; // Add more extensions as needed
  const fileExtension = url.substring(url.lastIndexOf(".")).toLowerCase();
  if (videoExtensions.includes(fileExtension)) {
    return true;
  }

  // Check for YouTube video URLs
  const youtubePattern =
    /(?:https?:\/\/)?(?:www\.)?youtu(?:\.be\/|be\.com\/watch\?v=)([\w-]{11})/;
  return youtubePattern.test(url);
};

// Documentacion: https://react-slideshow-image.netlify.app/?path=/docs/examples-responsive--page
const addUrl = (media: string): string => {
  if (isVideoByDomain(media)) {
    console.log("video", media);
    return media;
  }
  const url = `${API_URL}${media}`;
  console.log(url);
  return url;
};

const SlideShow = (props: Props) => {
  const navigate = useNavigate();
  const slideRef = useRef<SlideshowRef>(null);

  return (
    <Box>
      <Slide
        slidesToScroll={1}
        slidesToShow={1}
        indicators={true}
        autoplay={false}
        ref={slideRef}
        responsive={responsiveSettings}
      >
        {props.data.map((item) => (
          <div className="slideShowItem">
            <Card sx={{ maxWidth: 400 }}>
              {!isVideoByDomain(item.media) ? (
                <CardMedia
                  sx={{ height: 320 }}
                  image={addUrl(item.media)}
                  title={item.title}
                />
              ) : (
                <VideoPreview videoUrl={item.media} />
              )}
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {Parser().parse(sanitizeHtml(item.body))}
                </Typography>
              </CardContent>
              <CardActions className="cardButton">
                {item.moreInfoLabel ? (
                  <Button
                    onClick={() => {
                      window.open(item.moreInfo, "_blank");
                    }}
                    size="small"
                  >
                    {item.moreInfoLabel}
                  </Button>
                ) : (
                  <div />
                )}
                <Button
                  onClick={() => {
                    navigate("/game-mode");
                  }}
                  size="small"
                >
                  {props.startPlayingTitle}
                </Button>
              </CardActions>
            </Card>
          </div>
        ))}
      </Slide>
    </Box>
  );
};

export default SlideShow;
